export default __webpack_public_path__ + "static/media/farmer.a12ac895.png";